import Vue from "vue";

Vue.component("multiradiobutton", {
    props: [ "model", "items","loadingText", "loading", "isReadOnly"],
    data() {
        return {
            selectedValue: this.model
        };
    },
    methods: {
       
        checkIfSelected: function (value) {
            let result = false;
           
            return result;
        }
    },
    watch: {
        selectedValue: function(val){

            this.$emit("update:model", val);
        },
        model: function (val) {
            this.selectedValue = val;
        }
        
    },
    mounted() {
       
        if (this.model) {
            
            this.selectedValue = this.model.toString();
        }
    },
    template: `
		<div v-if="loading">
			<loading :loading-text="loadingText"></loading>
		</div>
		<div v-else>
			<b-field v-if="!isReadOnly" :key="item.value" v-for="item in items">
				<b-radio v-model="selectedValue" :disabled="isReadOnly" :native-value="item.value">
					{{ item.text }}
				</b-radio>
			</b-field>
            <div v-if="isReadOnly" class="field" :key="item.value" v-for="item in items">
		        <label class="b-radio radio is-disabled" >
			        <input type="radio" disabled="disabled" true-value="true"  :checked="selectedValue == item.value ? 'True' : null" />
			        <span class="check"></span>
			        <span class="control-label">
				        	{{ item.text }}
			        </span>
		        </label>
	        </div>
            
		</div>
	`
});